import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import { useKeywordListComposerContext } from "../KeywordListComposerContext";
import { KeywordListComposerInput } from "../KeywordListComposerInput";

import { KeywordsList } from "./KeywordsList";
import { SelectionBanner } from "./SelectionBanner";
import { Suggestions } from "./Suggestions";

const { carbon } = colorsPalettes;

const Container = styled(FlexColumn)`
    height: 100%;
`;

const PreviewContainer = styled(Container)`
    background-color: ${carbon[25]};
    overflow: hidden;
`;

export const ListItems = () => {
    const { query, bulkEditMode } = useKeywordListComposerContext();

    return (
        <Container>
            {bulkEditMode ? <SelectionBanner /> : <KeywordListComposerInput />}
            {query.length > 0 ? <Suggestions /> : <KeywordsList />}
        </Container>
    );
};

export const PreviewListItems = () => {
    return (
        <PreviewContainer>
            <KeywordsList
                displayHeaders={false}
                displayActionItems={false}
            />
        </PreviewContainer>
    );
};
